import * as React from 'react'
import cn from 'classnames'
import WebpImage from 'components/presenter/image/WebpImage'
import * as styles from './styles.module.css'

const JetsoBanner = ({className, poster, alt}) => (
    <WebpImage className={cn(styles.banner, className)} src={poster.url} alt={alt} />
  )

export default JetsoBanner